import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Megaphone } from "lucide-react";
import { api } from "@/lib/api";
import { fdatetime } from "@/lib/format";
import { EmptyState, Loader, PageTitle } from "@/components/common";

export function AnnouncementDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => {
    api.get(`/announcements/${id}`).then(({ data }) => setA(data)).catch(() => setA(false));
  }, [id]);
  if (a === null) return <Loader />;
  if (!a) return <EmptyState icon={Megaphone} title="Annonce introuvable" />;
  return (
    <article className="mr-fade-up space-y-5" data-testid="announcement-detail">
      <Link to="/app/annonces" className="mr-btn-ghost -ml-3"><ArrowLeft size={16} /> Toutes les annonces</Link>
      <p className="mr-eyebrow">Annonce du bureau</p>
      <h1 className="font-display font-bold text-2xl sm:text-3xl tracking-tight" data-testid="announcement-detail-title">{a.title}</h1>
      <p className="text-xs text-mr-muted tabular">{fdatetime(a.sent_at || a.created_at)} · {a.author_name}</p>
      <div className="mr-card whitespace-pre-wrap text-mr-text2 leading-relaxed" data-testid="announcement-detail-body">{a.body}</div>
    </article>
  );
}

export default function Announcements() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/announcements").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  return (
    <div className="mr-fade-up" data-testid="member-announcements">
      <PageTitle eyebrow="Club" title="Annonces du bureau" />
      {items === null ? <Loader /> : items.length === 0 ? <EmptyState icon={Megaphone} title="Aucune annonce" text="Les annonces que le bureau vous adresse apparaîtront ici." /> : (
        <ul className="space-y-3">{items.map((a) => (
          <li key={a.id}><Link to={`/app/annonces/${a.id}`} data-testid="member-announcement-row" className="mr-card block hover:border-mr-text2 transition-colors">
            <p className="font-medium">{a.title}</p>
            <p className="text-sm text-mr-text2 line-clamp-2 mt-1">{a.body}</p>
            <p className="text-xs text-mr-muted tabular mt-2">{fdatetime(a.sent_at)}</p>
          </Link></li>
        ))}</ul>
      )}
    </div>
  );
}
